import axios from 'axios';

const root = '/api/bms/car-brand';
async function unwrap(request) {
  let response;
  try { response = await request; }
  catch (error) { error.reported = true; throw error; }
  const { data } = response;
  if (data.code !== 200) {
    // The shared axios interceptor already displays non-blob API errors.
    const error = new Error(data.msg || '汽车品牌操作失败');
    error.reported = true;
    throw error;
  }
  return data.data;
}
export const listCarBrands = params => unwrap(axios.get(`${root}/list`, { params }));
export const saveCarBrand = (id, body) => unwrap(id ? axios.put(`${root}/${id}`, body) : axios.post(root, body));
export const deleteCarBrands = ids => unwrap(axios.post(`${root}/delete`, ids));
export const uploadCarBrandLogo = file => {
  const body = new FormData();
  body.append('file', file);
  return unwrap(axios.post(`${root}/logo`, body));
};
export async function exportCarBrands(params) {
  const { data } = await axios.get(`${root}/export`, { params, responseType: 'blob' });
  if ((data.type || '').includes('json')) {
    const error = JSON.parse(await data.text());
    throw new Error(error.msg || '导出失败');
  }
  return data;
}
